<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div class="section-editor-scope" style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-5">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>
        <div class="mb-5 ">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-checkbox small v-model="fields['container-page']" label="Container page" class="mt-0" />
            <v-checkbox small v-model="fields['top-padding']" label="Padding top" class="mt-0" />
            <v-checkbox
              small
              v-model="fields['bottom-padding']"
              label="Padding bottom"
              class="mt-0"
              :hide-details="true"
            />
          </div>
        </div>
        <div class="mb-5">
          <label class="label-input">Section background</label>
          <div class="d-flex align-center gap-3">
            <input
              type="color"
              style="width: 40px; height: 42px; margin-right: 10px;"
              :value="fields['card-container']"
              @change="onCardBgPick"
            />
            <v-text-field v-model="fields['card-container']" :hide-details="true" class="mt-0" />
          </div>
        </div>
        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Banner items</label>
            <v-btn small color="primary" @click="addBannerItem">Add banner</v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="`banner-${i}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Banner {{ i + 1 }}</span>
                  <v-btn :disabled="fields['list-item'].length === 1" small icon @click.stop="removeBannerItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-4">
                  <label class="label-input-sub">Subtitle</label>
                  <div class="group-item">
                    <div class="mb-2">
                      <v-checkbox
                        small
                        v-model="item.subtitle.show"
                        label="Show subtitle row"
                        class="mt-0"
                        :hide-details="true"
                      />
                    </div>
                    <div class="mb-2">
                      <v-text-field v-model="item.subtitle.text" class="mt-2" :hide-details="true" />
                    </div>
                    <v-row>
                      <v-col cols="12" md="6">
                        <UploadImage
                          :image="{ imageSrc: item.subtitle.icon }"
                          :height="`120`"
                          :typeUpload="'image'"
                          @callback="obj => (item.subtitle.icon = obj.imageSrc)"
                          @callbackDelete="item.subtitle.icon = ''"
                        />
                        <span class="caption">Subtitle icon</span>
                      </v-col>
                      <v-col cols="12" md="6">
                        <UploadImage
                          :image="{ imageSrc: item.subtitle.avatars }"
                          :height="`120`"
                          :typeUpload="'image'"
                          @callback="obj => (item.subtitle.avatars = obj.imageSrc)"
                          @callbackDelete="item.subtitle.avatars = ''"
                        />
                        <span class="caption">Subtitle avatars</span>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <div class="mb-4">
                  <div class="label-input-sub">Title</div>
                  <div class="group-item">
                    <div>
                      <v-checkbox v-model="item.title.show" label="Show title" :hide-details="true" class="mb-2 mt-0" />
                      <ckeditor :editor="editor" v-model="item.title.content" :config="editorConfig" />
                    </div>
                  </div>
                </div>

                <div class="mb-4">
                  <div class="label-input-sub">Images</div>
                  <div class="group-item">
                    <v-row>
                      <v-col cols="12" md="6">
                        <UploadImage
                          :image="{ imageSrc: item.imageDesktop }"
                          :height="`220`"
                          :typeUpload="'image'"
                          :resize="{ width: 1920, height: 'auto' }"
                          @callback="obj => (item.imageDesktop = obj.imageSrc)"
                          @callbackDelete="item.imageDesktop = ''"
                        />
                        <span class="caption">Desktop side image</span>
                      </v-col>
                      <v-col cols="12" md="6">
                        <UploadImage
                          :image="{ imageSrc: item.imageMobile }"
                          :height="`220`"
                          :resize="{ width: 1024, height: 'auto' }"
                          :typeUpload="'image'"
                          @callback="obj => (item.imageMobile = obj.imageSrc)"
                          @callbackDelete="item.imageMobile = ''"
                        />
                        <span class="caption">Mobile image</span>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <div class="mb-5">
                  <div class="label-input-sub">Button</div>
                  <div class="group-item">
                    <v-checkbox v-model="item.button.show" label="Show button" class="mt-0" />
                    <div class="mb-2">
                      <label>Button label</label>
                      <v-text-field v-model="item.button.text" :hide-details="true" />
                    </div>
                    <div class="mb-2">
                      <label>Button link</label>
                      <v-text-field v-model="item.button.link" :hide-details="true" />
                    </div>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div>
                          <label>Button background</label>
                          <div class="d-flex align-center gap-3">
                            <input
                              type="color"
                              style="width: 40px; height: 40px; margin-right: 5px"
                              :value="item.button.background"
                              @change="e => (item.button.background = e.target.value)"
                            />
                            <v-text-field v-model="item.button.background" :hide-details="true" class="mt-0" />
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <label>Button text color</label>
                          <div class="d-flex align-center gap-3">
                            <input
                              type="color"
                              style="width: 40px; height: 40px; margin-right: 5px"
                              :value="item.button.color"
                              @change="e => (item.button.color = e.target.value)"
                            />
                            <v-text-field v-model="item.button.color" :hide-details="true" class="mt-0" />
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <div class="d-flex justify-space-between align-center mt-3">
                  <v-checkbox v-model="item.blockOutstanding.show" label="Show outstanding block" class="mt-0 mb-0" />
                  <v-btn small text color="primary" @click="addOutstandingItem(i)">Add outstanding item</v-btn>
                </div>
                <v-expansion-panels accordion>
                  <v-expansion-panel
                    v-for="(outstandingItem, outIdx) in item.blockOutstanding.items"
                    :key="`out-${i}-${outIdx}`"
                  >
                    <v-expansion-panel-header>
                      <div class="d-flex justify-space-between align-center">
                        <span>Outstanding {{ outIdx + 1 }}</span>
                        <v-btn
                          small
                          text
                          color="error"
                          :disabled="item.blockOutstanding.items.length === 1"
                          @click="removeOutstandingItem(i, outIdx)"
                        >
                          <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="mb-2">
                        <label class="label-input-sub-small" for="heading">Heading</label>
                        <v-text-field v-model="outstandingItem.heading" :hide-details="true" />
                      </div>
                      <div>
                        <label class="label-input-sub-small" for="text">Description</label>
                        <v-text-field v-model="outstandingItem.text" :hide-details="true" />
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const defaultFields = () => ({
  title: 'Banner Kynorelle Section',
  'container-page': false,
  'card-container': '#FFFFFF',
  'top-padding': false,
  'bottom-padding': false,
  'list-item': [],
});

const defaultBannerItem = () => ({
  subtitle: {
    show: true,
    icon: '',
    text: '',
    avatars: '',
  },
  title: {
    show: true,
    content: '',
  },
  imageDesktop: '',
  imageMobile: '',
  button: {
    show: true,
    text: '',
    link: '#',
    background: '#003568',
    color: '#FFFFFF',
  },
  blockOutstanding: {
    show: true,
    items: [{ heading: '', text: '' }],
  },
});

export default {
  name: 'BannerKynorelleSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: defaultFields(),
    };
  },
  mounted() {
    const ex = this.sectionEditor.sectionExtract || {};
    const listItem = (ex['list-item'] || []).map(item => ({
      ...defaultBannerItem(),
      ...item,
      subtitle: {
        ...defaultBannerItem().subtitle,
        ...(item.subtitle || {}),
      },
      title: {
        ...defaultBannerItem().title,
        ...(item.title || {}),
        content:
          item.title && item.title.content !== undefined
            ? item.title.content
            : `<h2>${item.title?.heading || ''}</h2><p>${item.title?.tagline || ''}</p>`,
      },
      button: {
        ...defaultBannerItem().button,
        ...(item.button || {}),
      },
      blockOutstanding: {
        ...defaultBannerItem().blockOutstanding,
        ...(item.blockOutstanding || {}),
        items:
          item.blockOutstanding && Array.isArray(item.blockOutstanding.items) && item.blockOutstanding.items.length
            ? item.blockOutstanding.items.map(outstanding => ({ ...outstanding }))
            : [{ heading: '', text: '' }],
      },
    }));

    this.fields = {
      ...defaultFields(),
      ...ex,
      'list-item': listItem.length ? listItem : [defaultBannerItem()],
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    onCardBgPick(e) {
      this.fields['card-container'] = e.target.value;
    },
    addBannerItem() {
      this.fields['list-item'].push(defaultBannerItem());
    },
    removeBannerItem(index) {
      if (this.fields['list-item'].length <= 1) return;
      this.fields['list-item'].splice(index, 1);
    },
    addOutstandingItem(bannerIndex) {
      this.fields['list-item'][bannerIndex].blockOutstanding.items.push({ heading: '', text: '' });
    },
    removeOutstandingItem(bannerIndex, outstandingIndex) {
      const items = this.fields['list-item'][bannerIndex].blockOutstanding.items;
      if (items.length <= 1) return;
      items.splice(outstandingIndex, 1);
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerKynorelle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 200px;
}
.ck-editor__editable {
  min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.label-input-sub {
  font-size: 16px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.caption {
  font-size: 12px;
  color: #666;
  display: block;
  margin-top: 4px;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input-sub-small {
  font-size: 12px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
</style>
